import { gql } from '@apollo/client';

export default gql`
  mutation createVonageSession($agentEmail: String!, $isThalys: Boolean, $bookingReference: String!, $paymentData: JSON!) {
    createVonageSession(agentEmail: $agentEmail, isThalys: $isThalys, bookingReference: $bookingReference, paymentData: $paymentData)
  }
`;
